export default __webpack_public_path__ + "static/media/press-20.b0d89791.jpg";